import { TypeGuard } from '@principle-theorem/shared';
import type { IKnowledgeBasePushBody } from './knowledge-base-push-body';

export enum OvieHealthKnowledgeBaseAction {
  GetKnowledgeBase = 'getKnowledgeBase',
  PutKnowledgeBase = 'putKnowledgeBase',
  PatchKnowledgeBase = 'patchKnowledgeBase',
}

export function isOvieHealthKnowledgeBaseAction(
  data: unknown
): data is OvieHealthKnowledgeBaseAction {
  return TypeGuard.enumValue(OvieHealthKnowledgeBaseAction)(data);
}

export interface IOvieHealthKnowledgeBaseActionPayloadMap {
  getKnowledgeBase: IKnowledgeBasePushBody;
  putKnowledgeBase: IKnowledgeBasePushBody;
  patchKnowledgeBase: IKnowledgeBasePushBody;
}
